export default __webpack_public_path__ + "media/bootstrap-icons.ea98e12d.woff2";